<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Transaksi Pembayaran</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA TRANSAKSI</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                    <b-col v-if="dataDetailPembayaran.noFaktur != null"><strong>{{ dataDetailPembayaran.noFaktur }}</strong></b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Kwitansi</b-col>
                    <b-col v-if="dataDetailPembayaran.noKwitansi != null">{{ dataDetailPembayaran.noKwitansi }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status</b-col>
                    <b-col v-if="dataDetailPembayaran.status != null">{{ dataDetailPembayaran.status }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Status Pembayaran</b-col>
                    <b-col v-if="dataDetailPembayaran.statusPembayaran != null">{{ dataDetailPembayaran.statusPembayaran }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Jenis Pembayaran</b-col>
                    <b-col v-if="dataDetailPembayaran.jenis != null">{{ dataDetailPembayaran.jenis }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Metode Pembayaran</b-col>
                    <b-col v-if="dataDetailPembayaran.isTunai == true">Tunai</b-col>
                    <b-col v-else>Transfer</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Pembayaran di Cabang</b-col>
                    <b-col v-if="dataDetailPembayaran.cabang != null">{{ dataDetailPembayaran.cabang }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tanggal Pembayaran</b-col>
                    <b-col v-if="dataDetailPembayaran.tanggalPembayaran != null">{{ $helper.changeDateFormat(dataDetailPembayaran.tanggalPembayaran) }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Tipe Pelunasan</b-col>
                    <b-col v-if="dataDetailPembayaran.tipePelunasan == 1">Nasabah + SBG</b-col>
                    <b-col v-else-if="dataDetailPembayaran.tipePelunasan == 2">Nasabah + Nota Hilang</b-col>
                    <b-col v-else-if="dataDetailPembayaran.tipePelunasan == 3">Pelunasan Diwakilkan + SBG</b-col>
                    <b-col v-else-if="dataDetailPembayaran.tipePelunasan == 4">Pelunasan Diwakilkan + Surat Kuasa PGI (Apabila SBG Hilang)</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA ANGGOTA</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                    <b-col v-if="dataDetailPembayaran.noAnggota != null">{{ dataDetailPembayaran.noAnggota }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama Anggota</b-col>
                    <b-col v-if="dataDetailPembayaran.namaAnggota != null">{{ dataDetailPembayaran.namaAnggota }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA BARANG</h6>

                <div v-if="dataDetailPembayaran.emasDetail == null">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.jenisBarang != null">{{ dataDetailPembayaran.jenisBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.merkBarang != null">{{ dataDetailPembayaran.merkBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.tipeBarang != null">{{ dataDetailPembayaran.tipeBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>

                <div v-else>
                    <div v-if="dataDetailPembayaran.jenisBarang.id == 257">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.barang.jenis != null">{{ dataDetailPembayaran.barang.jenis.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.barang.merk != null">{{ dataDetailPembayaran.barang.merk.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.barang.tipe != null">{{ dataDetailPembayaran.barang.tipe.name }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                
                   
                </div>
                <div v-if="dataDetailPembayaran.emasDetail.beratBasah != null && dataDetailPembayaran.emasDetail.keping == null">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.jenisBarang != null">{{ dataDetailPembayaran.jenisBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.merkBarang != null">{{ dataDetailPembayaran.merkBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.tipeBarang != null">{{ dataDetailPembayaran.tipeBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Daftar Berat</b-col>
                        <b-col v-if="dataDetailPembayaran.emasDetail.listPotonganBerat != null && dataDetailPembayaran.emasDetail.listPotonganBerat.length != 0" class="detail-data-label">
                            <div v-for="(item, index) in dataDetailPembayaran.emasDetail.listPotonganBerat" :key="index">
                                - {{ item }}
                            </div>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Berat Kering</b-col>
                        <b-col>{{ dataDetailPembayaran.emasDetail.beratKering }} gram</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Potongan Berat</b-col>
                        <b-col>{{ dataDetailPembayaran.emasDetail.potonganBerat }} gram</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Berat Emas</b-col>
                        <b-col>{{ dataDetailPembayaran.emasDetail.beratEmas }} gram</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Hasil Gosokan</b-col>
                        <b-col v-if="dataDetailPembayaran.emasDetail.gosokanHilang == true">Hilang</b-col>
                        <b-col v-else>Tidak Hilang</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Cap Karat</b-col>
                        <b-col v-if="dataDetailPembayaran.emasDetail.adaCap == true">Ada</b-col>
                        <b-col v-else>Tidak Ada</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Ada Merk Perusahaan</b-col>
                        <b-col>{{ getLabelAdaMerkPerusahaan(dataDetailPembayaran.emasDetail.adaLogoPerusahaan) }}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kwitansi</b-col>
                        <b-col v-if="dataDetailPembayaran.emasDetail.adaKwitansi == true">Ada</b-col>
                        <b-col v-else>Tidak Ada</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Cap Tempelan</b-col>
                        <b-col v-if="dataDetailPembayaran.emasDetail.potonganKaratCapTempelan != 0">Ya (- {{ dataDetailPembayaran.emasDetail.potonganKaratCapTempelan }} Karat)</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.spesifikasi.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="(item, idx) in dataDetailPembayaran.spesifikasi"  v-bind:key="idx">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.kelengkapan.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="item in dataDetailPembayaran.kelengkapan"  v-bind:key="item">
                                    {{ item }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>

                <div v-else-if="dataDetailPembayaran.emasDetail.beratBasah == null && dataDetailPembayaran.emasDetail.keping == null">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.jenisBarang != null">{{ dataDetailPembayaran.jenisBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.merkBarang != null">{{ dataDetailPembayaran.merkBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.tipeBarang != null">{{ dataDetailPembayaran.tipeBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Cap Kwitansi</b-col>
                        <b-col v-if="dataDetailPembayaran.emasDetail.adaCapDanKwitansi == true">Ada</b-col>
                        <b-col v-else>Tidak Ada</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Berat</b-col>
                        <b-col>{{ dataDetailPembayaran.emasDetail.beratEmas }} gram</b-col>
                    </b-row>

                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Spesifikasi Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.spesifikasi.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="(item, idx) in dataDetailPembayaran.spesifikasi"  v-bind:key="idx">
                                    {{ item.name }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Kelengkapan Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.kelengkapan.length >= 1">
                            <ul class="list-circle-wrapper">
                                <li v-for="item in dataDetailPembayaran.kelengkapan"  v-bind:key="item">
                                    {{ item }}
                                </li>
                            </ul>
                        </b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>

                <div v-else-if="dataDetailPembayaran.emasDetail.beratBasah == null && dataDetailPembayaran.emasDetail.keping != null">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.jenisBarang != null">{{ dataDetailPembayaran.jenisBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Merk Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.merkBarang != null">{{ dataDetailPembayaran.merkBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Tipe Barang</b-col>
                        <b-col v-if="dataDetailPembayaran.tipeBarang != null">{{ dataDetailPembayaran.tipeBarang }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jumlah</b-col>
                        <b-col>{{ dataDetailPembayaran.emasDetail.keping }} Keping</b-col>
                    </b-row>
                </div>
                </div>
             
                
            </div>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">RINCIAN PEMBAYARAN</h6>
                <b-row class="mb-2" v-for="(item, idx) in dataDetailPembayaran.detail"  v-bind:key="idx">
                    <b-col cols="4" class="detail-data-label">{{item.name}}</b-col>
                    <b-col v-if="item.nominal == null">{{$helper.addThousandSeparator(item.nominal)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(item.nominal)}} </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Angsuran Pokok</b-col>
                    <b-col v-if="dataDetailPembayaran.angsuranPokok == null">{{$helper.addThousandSeparator(dataDetailPembayaran.angsuranPokok)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.angsuranPokok)}} </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Total Pembayaran</b-col>
                    <b-col v-if="dataDetailPembayaran.nominalPembayaran == null">{{$helper.addThousandSeparator(dataDetailPembayaran.nominalPembayaran)}} </b-col>
                    <b-col v-else>Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.nominalPembayaran)}} </b-col>
                </b-row>
            </div>
            <div class="detail-data-wrapper mb-4" v-if="dataDetailPembayaran.isTunai">
                 <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Diterima Dari Nasabah</b-col>
                    <b-col v-if="dataDetailPembayaran.nominalDiterima != null">Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.nominalDiterima)}} </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Kembalian</b-col>
                    <b-col v-if="dataDetailPembayaran.nominalKembalian != null">Rp. {{$helper.addThousandSeparator(dataDetailPembayaran.nominalKembalian)}} </b-col>
                </b-row>
            </div>
            <div v-if="dataDetailPembayaran.midtrans != null" class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA MIDTRANS</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Metode</b-col>
                    <b-col v-if="dataDetailPembayaran.midtrans.name != null">{{ dataDetailPembayaran.midtrans.name }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Midtrans Order ID</b-col>
                    <b-col v-if="dataDetailPembayaran.midtrans.orderId != null">{{ dataDetailPembayaran.midtrans.orderId }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Midtrans Transaction ID</b-col>
                    <b-col v-if="dataDetailPembayaran.midtrans.transactionId != null">{{ dataDetailPembayaran.midtrans.transactionId }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="cetak-sbg-btn" v-if="dataDetailPembayaran.status != 'Request Void' && dataDetailPembayaran.status != 'Void' && dataDetailPembayaran.midtrans == null">
                <b-row class="ml-0">
                    <b-button variant="pgiBtn" name="cetakBtn" @click="confirmCetakKwitansi">
                        <i class="fa fa-print mr-2"></i> Cetak Kwitansi 
                    </b-button>        
                    <b-col class="mt-2">
                        # Print: {{ dataDetailPembayaran.counterPrint }}
                    </b-col>
                    <b-button class="mr-3" variant="danger" name="cetakBtn" @click="confirmVoidPembayaran">
                        Void
                    </b-button>
                </b-row>
                <br>
                <b-button v-if="dataDetailPembayaran.tipePelunasan == 2" variant="pgiBtn" class="mb-0 download-btn" @click="$bvModal.show('modal-print-nota-hilang')">
                        <i class="fa fa-download mr-2"></i>
                        Cetak Form Nota Hilang
                </b-button>
            </div>
        </b-card>
        <b-modal id="modal-confirm-cetak" size="md" title="Confirm Cetak Kwitansi" no-close-on-backdrop >
            <div v-if="isLoading">
                <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>  Loading data...</strong>
                </div>
            </div>
            <div v-else>
                Apakah anda yakin untuk mencetak Kwitansi ini?
                
                <b-alert v-if="requireFoto != null && dataDetailPembayaran.status != 'Terbayar'" variant="info" class="my-2" show>
                    <h4 class="text-danger"><strong>Perhatian !</strong> </h4>
                    Mohon persiapkan foto-foto berikut sebagai bukti pelunasan:
                    <div v-if="requireFoto.required && requireFoto.required.length != 0">
                        <strong>Wajib</strong>
                        <ul class="pl-4 mb-0">
                            <li v-for="(item, index) in requireFoto.required" :key="index">{{ item }}</li>
                        </ul>
                    </div>  
                                      
                    <div class="my-2" v-if="requireFoto.optional && requireFoto.optional.length != 0">
                        <strong>Opsional, jika ada (minimal 1 diisi)</strong>
                        <ul class="pl-4 mb-0">
                            <li v-for="(item, index) in requireFoto.optional" :key="index">{{ item }}</li>
                        </ul>
                    </div>
                </b-alert>
                <div v-if="dataDetailPembayaran.status != 'Terbayar' && dataDetailPembayaran.tipePelunasan == 2 | dataDetailPembayaran.tipePelunasan == 4" >
                  
                    Contoh foto yang harus diupload :
                 
                    <img src="https://earth.pgindonesia.com/STATIC/cthnthlng_299281.jpeg" class="w-100 my-2" alt="">
            
                       Pastikan:
                       <ul>
                        <li>⁠Wajah nasabah / yang mewakilkan, jelas dan tidak blur.</li>
                        <li>Nota hilang / surat kuasa jelas dan tidak blur.</li>
                        <li>Sambil memegang KTP asli.</li>
                        <li>⁠⁠Materai sudah ditandatangani nasabah / yang mewakilkan.</li>
                        <li>⁠⁠Kolom saksi sudah ditandatangani petugas.</li>
                       </ul>  
                       
                    <div class="action-browse-wrapper" style="width: 400px">
                        <b-form-file
                            v-model="fotoNotaHilang" name="fotoBarangPendukung"
                            :state="Boolean(fotoNotaHilang)"
                            label="asdasd"
                            drop-placeholder="Drop file here..."
                            accept=".jpg, .png, .jpeg"
                            >
                        </b-form-file>
                        
                        <b-button v-if="dataDetailPembayaran.tipePelunasan == 2" variant="cancelBtn">
                            <i class="fa fa-upload mr-2"></i>
                            Upload Nota Hilang dan Nasabah / Yang Mewakilkan
                        </b-button>

                        <b-button v-if="dataDetailPembayaran.tipePelunasan == 4" variant="cancelBtn">
                            <i class="fa fa-upload mr-2"></i>
                            Upload Surat Kuasa dan Yang Mewakilkan
                        </b-button>
                        
                        <div v-if="fotoNotaHilang">
                            Terdapat file: <a :href="fileUrl" target="blank">Buka File</a>
                        </div>
                    </div>
                </div>

                <div v-if="dataDetailPembayaran.status != 'Terbayar' && dataDetailPembayaran.tipePelunasan == 1 | dataDetailPembayaran.tipePelunasan == 3" >
                    Catatan: SBG Pelunasan adalah SBG yang bagian penyerahan barangnya, sudah ditandatangani oleh nasabah / yang mewakilkan
                </div>
            </div>

            <template v-slot:modal-footer="{ cancel }" >
                <b-button variant="secondary" name="cancelVoidBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button @click="onSubmit" type="submit" name="voidSubmitBtn" variant="primary" :disabled="isSubmitting" form="voidPembayaranForm">
                    {{ isSubmitting ? "Loading..." : "Ok" }}
                </b-button>
            </template>
         
        </b-modal>
    
        <b-modal id="modal-confirm-void" title="Confirm Void Pembayaran" no-close-on-backdrop>
                <b-form id="voidPembayaranForm" @submit.prevent="onVoid">
                    <div class="form-content-wrapper mb-0">
                        <b-form-group label="Keterangan/ Alasan Void" class="mb-0">
                            <b-form-textarea
                                v-model="input.keteranganVoid" name="keteranganVoid"
                                rows="3"
                                max-rows="6"
                                required
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                    <b-alert variant="primary" class="mt-3 mb-0" :show="dataDetailPembayaran.status == 'Confirmed'">* Pengajuan void ini akan melewati approval dari AM sebelum disahkan</b-alert>
                </b-form>
         
            <template v-slot:modal-footer="{ cancel }" >
                <b-button variant="secondary" name="cancelVoidBtn" @click="cancel()">
                    Cancel
                </b-button>
                <b-button type="submit" name="voidSubmitBtn" variant="danger" :disabled="isSubmitting" form="voidPembayaranForm">
                    {{ isSubmitting ? "Sedang mengirim..." : "Kirim" }}
                </b-button>
            </template>
        </b-modal>

        <b-modal title="Print Kwitansi Pembayaran" ok-only no-close-on-esc no-close-on-backdrop size="xl" id="modal-print" @hide="pindahKeTransaksiPby">
            <b-alert v-if="alertModeId == 1" show variant="danger">
                <strong>PERHATIAN!<br />FAKTUR INI BERSTATUS ORDER LELANG. MOHON KEMBALIKAN UNIT / BARANG KEMBALI KE GUDANG!</strong>
            </b-alert>
            <p class="smallText text-muted">
                Bila tombol print / cetak tidak ditemukan, anda dapat melakukan pencetakan dengan cara klik kanan pada lembar yang akan dicetak, lalu pilih Print.
            </p>
            <b-row class="mb-2">
                <b-col class="detail-data-label">Kwitansi</b-col>
            </b-row>
            <b-row class="mb-2">
                <b-col><iframe width="100%" height="300" :src= urlKwitansi frameborder="0" allowfullscreen></iframe></b-col>
            </b-row>
        </b-modal>

        <b-modal title="Cetak Form Nota Hilang" ok-only no-close-on-esc no-close-on-backdrop size="xl"
            id="modal-print-nota-hilang">
            <b-row class="mb-2">
                <b-col><iframe width="100%" height="500" :src="$baseFilePath + filePathDownload" frameborder="0" allowfullscreen></iframe></b-col>
            </b-row>
        </b-modal>
    </div>
</template>

<script>
import imageCompression from 'browser-image-compression';
export default {
    name: 'detail-transaksi-pembayaran',
    data(){
        return{
            id: null,
            initStatus: 0,
            dataDetailPembayaran: [],
            isSubmitting: false,
            urlKwitansi: null,
            input: {
                keteranganVoid: ""
            },
            isLoading: false,
            alertModeId: 0, // Update 26 Sept 2023: Digunakan saat cetak kwitansi. Response ID 0 menandakan tidak ada apa-apa, 1 menandakan barang tersebut sedang dalam order lelang
            requireFoto: null,
            filePathDownload: '',
            fotoNotaHilang: null
        }
    }, 
    computed: {
        fileUrl() {
            if (this.fotoNotaHilang) {
                return URL.createObjectURL(this.fotoNotaHilang);
            }
            return null;
        },
    },
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSingleGadai = this.$axios.get(`gadai-pembayaran/${this.id}`).then(response => {
                this.dataDetailPembayaran = response.data
                if (this.dataDetailPembayaran.emasDetail != null && this.dataDetailPembayaran.spesifikasi != null) {
                    this.dataDetailPembayaran.spesifikasi  = JSON.parse(this.dataDetailPembayaran.spesifikasi);
                }
                console.log(response.data);
                if (response.data.tipePelunasan == 2 || response.data.tipePelunasan == 4) {
                        this.$axios.get(`gadai-evidence/get-nota-hilang?gadaiPembayaranId=${this.id}` ).then(response => {
                        this.filePathDownload = response.data.name
                    })
                }
             
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

           

            Promise.all([getSingleGadai]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        //----------------- Submit Request Cetak Kwitansi -----------------

        async onSubmit(){
            if ( this.dataDetailPembayaran.status != "Terbayar" && this.dataDetailPembayaran.tipePelunasan == 2 | this.dataDetailPembayaran.tipePelunasan == 4 ) {
                if (this.fotoNotaHilang == null) {   
                    return this.$helper.toastErr(this, "Mohon upload foto nota hilang !")
                }
            }

            this.isSubmitting = true

            let payload = new FormData()
            payload.append("pembayaranId", this.id)

            if (this.fotoNotaHilang != null && this.dataDetailPembayaran.tipePelunasan == 2 | this.dataDetailPembayaran.tipePelunasan == 4) {
                
                
                var imageFile = this.fotoNotaHilang;

                var controller = new AbortController();

                var options = {
                    // other options here
                    maxSizeMB: 1,
                    signal: controller.signal,
                }

                var compressedFile = await imageCompression(imageFile, options);

                function blobToFile(theBlob, fileName) {
                    return new File([theBlob], fileName, { lastModified: new Date().getTime(), type: theBlob.type })
                }

                var fileType = await blobToFile(compressedFile, imageFile.name);

                payload.append("fotoNotaHilang", fileType)
            }

            this.$axios.post("gadai-pembayaran/cetak-kwitansi/", payload).then(response => {
                this.$helper.setFlash(`Request Cetak Kwitansi berhasil dilakukan!`)
                this.$bvModal.hide("modal-confirm-cetak")
                
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)

                this.urlKwitansi = this.$baseFilePath + response.data.name

                // Update 26 September 2023 - Lihat response id, bila 1, maka tampilkan alert bahwa barang dalam order lelang
                this.alertModeId = response.data.id

                this.$bvModal.show("modal-print")

                this.dataDetailPembayaran.counterPrint++
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },

        //----------------- Submit Request Void -----------------
        
        onVoid(){
            this.isSubmitting = true

            let payload = new FormData()
            payload.append("pembayaranId", this.id)
            payload.append("keterangan", this.input.keteranganVoid)

            this.$axios.post("gadai-pembayaran/request-void/", payload).then(() => {
                this.$helper.setFlash(`Void Pembayaran berhasil dilakukan!`)
                this.$bvModal.hide("modal-confirm-void")
                
                let path = this.$route.path.split("/")
                path.pop()
                path = path.join("/")
                this.$router.push({ path })
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isSubmitting = false
            })
        },


        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        confirmCetakKwitansi(){
            if(this.dataDetailPembayaran.tipePelunasan != null){
                this.fetchStatusTipe()
            }
            this.fotoNotaHilang = null
            this.$bvModal.show("modal-confirm-cetak")
        },

        fetchStatusTipe(){
            this.isLoading = true
            this.$axios.get("gadai-pembayaran/pelunasan-evidence-hints?tipePelunasan="+ this.dataDetailPembayaran.tipePelunasan).then(response => {
                this.requireFoto = response.data
                this.isLoading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.isLoading = false
            })
        },

        confirmVoidPembayaran(){
            this.$bvModal.show("modal-confirm-void")
        },

        pindahKeTransaksiPby(){
            let path = this.$route.path.split('/')
            path.pop()
            path = path.join("/")
            this.$router.push({ path })
        },
        getLabelAdaMerkPerusahaan(value) {
            if (value === true) return 'Ya'
            if (value === false) return 'Tidak'
            return '-'
        }
    },

    created(){
        this.init()
    }
}
</script>
<style scoped>
.action-browse-wrapper .custom-file{
    width: 400px;
    opacity: 0;
    z-index: 1;
}
</style>